export default __webpack_public_path__ + "static/media/banner_faq.b7626b5f.jpg";